<script setup lang="ts">
/**
 * Link-style action: always an 11px lucide icon + a word.
 * Green (primary) is reserved for the one action in a card or section header.
 * Inside rows and footers the link is neutral and turns primary on hover.
 */
withDefaults(defineProps<{ label: string; variant?: 'header' | 'row' | 'danger' | 'muted' }>(), { variant: 'row' })
</script>

<template>
  <button
    type="button"
    class="hit inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-[length:var(--type-meta)] [&_svg]:size-[var(--measure-11px)] [&_svg]:shrink-0"
    :class="{
      'text-primary': variant === 'header',
      'text-foreground hover:text-primary': variant === 'row',
      'text-muted-foreground hover:text-primary': variant === 'muted',
      'text-destructive': variant === 'danger',
    }"
  >
    <slot name="icon" />{{ label }}
  </button>
</template>
